import React from 'react';
import styles from './styles.module.css';
import { SidebarMenu } from 'components/sidebar-menu';
import { Footer } from 'components/footer';
import { MenuFooter } from 'components/menu-footer';
// import { RegionAutodetect } from 'components/region-autodetect';
import { Background } from 'components/background';

interface LayoutProps {
  children: React.ReactNode;
  hasFooter?: boolean;
  isMain?: boolean;
  bgVariant?: 'basic' | 'home';
  isSearchInputMobileVisible?: boolean;
}

export const Layout = ({
  children,
  hasFooter,
  bgVariant,
  isSearchInputMobileVisible,
}: LayoutProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.layout_wrapper}>
        <SidebarMenu />
        {/* <RegionAutodetect /> */}
        <div className={styles.backgroundParent}>
          <div className={styles.main}>
            <Background bgVariant={bgVariant} />
            {children}
            {hasFooter && <Footer />}
            <MenuFooter isSearchInputVisible={isSearchInputMobileVisible} />
          </div>
        </div>
      </div>
    </div>
  );
};
